import { Component, inject } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';
import type { DataSourceService } from '@core/views-types';
import { dataSourceService$ } from '@core/views-util';

@Component({
  selector: 'rt-views-sample-data-infobox',
  templateUrl: './sample-data-infobox.component.html',
  styleUrls: ['./sample-data-infobox.component.less'],
  imports: [InfoboxComponent, TranslatePipe],
})
export class SampleDataInfoboxComponent {
  private dataSourceService$ = inject(dataSourceService$);
  private dataSourceService: DataSourceService;

  private untilDestroyed = injectUntilDestroyed();

  constructor() {
    this.dataSourceService$.pipe(this.untilDestroyed).subscribe(dataSourceService => {
      this.dataSourceService = dataSourceService;
    });
  }

  public onRemoveSampleData(): void {
    if (this.dataSourceService) {
      this.dataSourceService.onRemoveSampleData();
    }
  }
}
